import styled from "styled-components";
import { Heading, Box, Link, Image } from "rebass/styled-components";
import Page from "../../components/Page";
import Header from "../../components/Header";
import CTA from "../../components/CTA";
import Footer from "../../components/Footer";
import { apiEndpoint } from "../../prismic-configuration";
import AboutStatic from "../../components/AboutStatic";
import { RichText } from "prismic-reactjs";
import CatalogDynamic from "../../components/CatalogDynamic";
import Prismic from "@prismicio/client";

const ImageBox = styled(Image)`
  padding: 0;
  width: 100%;
  vertical-align: middle;
`;

const Merk = (props) => {
  const { doc, categories, brands } = props;
  const { data } = doc;

  return (
    <Page
      title={"MERLET | " + data.name}
      description="Breed assortiment aan bedrijfs- en promotiekledij met
        de mogelijkheid tot personalisatie."
    >
      <Header />
      <AboutStatic>
        <Box pt="6">
          {/* {categories &&
            categories.length > 0 &&
            categories.map((category, i) => {
              return (
                <>
                  <Link href={"/" + category.uid}>
                    <a>
                      <Heading
                        variant="title"
                        sx={{ textTransform: "capitalize" }}
                      >
                        {category.data.name}
                      </Heading>
                    </a>
                  </Link>
                  <Link href={"/" + category.uid}>
                    <a>
                      <Heading
                        variant="title"
                        sx={{ textTransform: "capitalize" }}
                      >
                        {category.data.name}
                      </Heading>
                    </a>
                  </Link>
                  <Link href={"/" + category.uid}>
                    <a>
                      <Heading
                        variant="title"
                        sx={{ textTransform: "capitalize" }}
                      >
                        {category.data.name}
                      </Heading>
                    </a>
                  </Link>
                </>
              );
            })} */}

          <Box fontSize={7}>{data.name}</Box>
          <Box py={4} sx={{ p: { m: 0 } }}>
            {data.intro && RichText.render(data.intro)}
          </Box>
        </Box>
      </AboutStatic>
      <Box
        p="5"
        sx={{
          bg: "lightYellow",
        }}
      >
        {data.catalogus_list.map((catalogus, i) => {
          return (
            <Box
              maxWidth="300px"
              mx="auto"
              sx={{
                position: "relative",
              }}
            >
              <Link href={catalogus.catalogus_href.url} target="_blank">
                <a>
                  <ImageBox
                    src={catalogus.catalogus_image.url}
                    alt={catalogus.catalogus_image.alt}
                    sx={{
                      cursor: "pointer",
                    }}
                  ></ImageBox>
                </a>
              </Link>
              <Box
                py="2"
                variant="title"
                color="dark"
                sx={{ textTransform: "uppercase" }}
              >
                Catalogus
              </Box>
              <Box>{catalogus.catalogus_name}</Box>
            </Box>
          );
        })}

        <Box
          maxWidth="300px"
          px="3"
          sx={{
            bg: "lightYellow",
          }}
        ></Box>
      </Box>
      <CatalogDynamic merken={brands} />

      {data.body.map((body, i) => {
        switch (body.slice_type) {
          case "brand_catalogus_list":
            return <CatalogDynamic merken={brands} />;
          case "cta":
            return <CTA data={body} key={`slice-${i}`} />;
          default:
            return null;
        }
      })}
      <Footer />
    </Page>
  );
};

Merk.getInitialProps = async (context) => {
  const { query } = context;

  const pbm = await Prismic.client(apiEndpoint).getByUID(
    "brand",
    query.pid,
    {}
  );

  const categoriesIds = [];

  pbm.data.categories.map((cat, i) => {
    categoriesIds.push(cat.category.id);
  });

  const categories = await Prismic.client(apiEndpoint).query([
    Prismic.Predicates.any("document.id", categoriesIds),
  ]);

  const brands = await Prismic.client(apiEndpoint).query([
    Prismic.Predicates.at("document.type", "brand"),
    Prismic.Predicates.any("my.brand.categories.category", categoriesIds),
  ]);

  return { doc: pbm, categories: categories.results, brands: brands.results };
};

export default Merk;
